import { createSelector } from 'reselect';
import { ReduxState } from '../state';
import { TopbarExpandedMenu, TopbarDropdownAlignment } from './constants';
import { TopbarState } from './state';

const TopBarSelector = (state: ReduxState): TopbarState => state.TopBar;

export const selectTopBarExpandedMenu = createSelector(
  TopBarSelector,
  (topBar): TopbarExpandedMenu | null => {
    return topBar.expandedMenu;
  }
);

export const selectTopBarIsMenuTriggeredClick = createSelector(
  TopBarSelector,
  (topBar): boolean => {
    return topBar.isMenuTriggeredClick;
  }
);

export const selectTopBarExpandedMenuAlignment = createSelector(
  TopBarSelector,
  (topBar): TopbarDropdownAlignment => {
    return topBar.expandedMenuAlignment;
  }
);

export const selectTopBarSiteNavRendered = createSelector(
  TopBarSelector,
  (topBar): boolean => {
    return topBar.siteNavRendered;
  }
);
